module.exports = {
  WarehouseNo: '进仓编号',
  Warehouse: '仓库名称',
  WarehouseInDate: '实际进仓时间',
  State: '进仓状态',
  PackageWarehouseInDate: '包装-实际进仓时间',
  PackageWarehouseOutDate: '包装-实际出仓时间',
  ReceiptNumber: '回执编号',
  ReceiptNo: '回执单号',
  PortOfDestination: '目的港',
  StorageDate: '入库时间',
  DeliveryDate: '出库时间',
  StorageDay: '入库日期',
  ActStorageDay: '实际入库日期',
  DeliveryDay: '出库日期',
  ActDeliveryDay: '实际出库日期',
  InputTime: '录入时间',
  DataEntryClerk: '录入人',
  NumberOfCases: '件数',
  Weight: '重量',
  Volume: '体积',
  ComputationIsAffectedByDampness: '破损受潮',
  IsNotComputationIsAffectedByDampness: '是否破损受潮',
  ComputationIsAffectedByDampnessNum: '破损受潮件数',
  IntoTheWarehousePhotos: '进仓照片',
  WarehouseName: '仓库名称',
  DeliveryMode: '出库方式',
  Warehouseman: '仓库员',
  WarehouseLocation: '库位',
  StorageLocation: '库位',
  TemperatureRequirement: '温控要求',
  DeliveryCmp: '送货公司',
  IssueOrNot: '是否出库',
  PalletSum: '托盘数量',
  ReceiveDc: '是否收到文件',
  LicensePlate: '车牌',
  DescriptionOfGoods: '货物描述',
  HandlingOpinions: '处理意见',
  Remark: '备注',
  SealingWeight: '关封重量',
  Driver: '司机',
  DriverPhone: '司机电话',
  IsTheGoodsClosed: '是否关封货',
  WarehouseInformation: '仓库信息',
  CargoDetails: '货物明细',
  CargoPhotos: '货物照片',
  OperationRequirements: '操作要求',
  SelectFile: '选择文件',
  DeleteFile: '删除文件',
  AddCargo: '加入货物',
  Detail: '明细',
  Summary: '汇总',
  FillData: '填充',
  maintenanceAllType: '货箱号&商品信息',
  maintenanceContainerNoType: '仅货箱号',
  maintenanceWeightAndSizeType: '仅商品信息',
  DeleteCargo: '移除货物',
  JobNumberInformation: '工作号信息',
  Statistics: '统计',
  Number: '票数',
  QuantityActual: '实际件数',
  WeightActual: '实际重量',
  CubageActual: '实际体积',
  WarehouseOutState: '出库状态',
  WarehouseInState: '入库状态',
  WarehouseIn: '入库',
  WarehouseOut: '出库',
  NewWarehouseFee: '新增仓库费',
  WarehousePhotos: '仓库照片',
  StorageDayCanNotBeNull: '入库日期不能为空.',
  DeliveryDayCanNotBeNull: '出库日期不能为空.',
  WarehouseInSuccess: '已成功入库.',
  WarehouseOutSuccess: '已成功出库',
  NoChoiceWarehouseToBePrinted: '没有选择需要打印的仓库信息!',
  PleaseSelectTheWarehousingNoticeToBeDeleted: '请选择需要删除的进仓通知单',
  WarehousingNotice: '进仓通知单',
  AreYouSureToDeleteThisWarehousingNotice: '是否确定删除此进仓通知单?',
  DeleteWarehousingNotice: '删除进仓通知单',
  ImportingData: '正在导入数据',
  ThisOperationIsAnAsynchronousImport: '此操作为异步导入，您可在“文件存储->上传日志”中查看导入结果',
  ViewResults: '查看结果',
  BatchImportWarehousing: '批量导入进仓',
  BatchImportWarehousingData: '批量导入进仓数据',
  NoWarehouseReceiptSelected: '未选择进仓单',
  Checklist: '核单',
  ReturnGoods: '退件',
  OnlySave: '仅保存',
  Save: '保存',
  SaveAndWeigh: '保存并称重',
  SaveAndChecklist: '保存并核单',
  WeighAndChecklist: '称重并核单',
  PoOriginalOrderNo: 'PO(原单号)',
  ServiceChannel: '服务渠道',
  DestinationDeliveryMethod: '目的地派送方式',
  OverseasWarehouse: '海外仓',
  DestinationCountry: '目的国',
  Weigh: '称重',
  ReceivingWarehouse: '收货仓库',
  CommissionNo: '委托编号',
  OverseasWarehouseCode: '海外仓库编码',
  RemoteWarehouse: '偏远仓',
  boxLengthPlaceholder: '长',
  boxWidthPlaceholder: '宽',
  BoxHeightPlaceholder: '高',
  SizeNotZero: '长宽高件数不能小于等于0',
  EstEnteringAmazonWarehouse: '预期入亚马逊仓时间',
  ChargingMethod: '计费方式',
  Total: '总',
  WeighTime: '称重时间',
  weighCheckMsg: '本条入库信息已{0}，不能称重',
  ChecklistTime: '核单时间',
  ReturnGoodsTime: '退件时间',
  CourierServicesCompany: '快递公司',
  Electric: '是否带电',
  Magnetic: '是否带磁',
  Powdery: '是否粉末',
  Liquid: '是否液体',
  BatchMaintenance: '批量维护',
  PickingGoods: '按客户数据拣货',
  AdjustChargeWeight: '调整计费重量',
  ContainerNo: '货箱编号',
  BoxesNumber: '箱数',
  SingleBoxWeight: '单货箱重量（KG）',
  DialogSingleBoxWeight: '单货箱重量(KG)',
  BoxLength: '货箱长度（CM）',
  BoxWidth: '货箱宽度（CM）',
  BoxHeight: '货箱高度（CM）',
  UnitRate: '申报单价（单个产品）',
  Quantity: '申报数量（单箱）',
  BoxSize: '单箱尺寸',
  HsCode: '海关编码',
  Brand: '品牌',
  BrandType: '品牌类型',
  ModelNo: '型号',
  MaterialQuality: '材质',
  Purpose: '用途',
  SalesLink: '销售链接',
  SalesPrice: '销售价格',
  PictureUrl: '图片',
  WeightKg: '重量（KG）',
  CargoType: '货物类型',
  ProductDescription: '产品描述',
  CheckWeighTime: '本条入库信息已称重，是否更新称重数据？',
  ChecklistTimeTip: '核单时间【{0}】不能小于称重时间【{1}】，请检查。',
  ReturnReason: '退件原因',
  ReturnGoodsTips: '包含{0}数据，请确认是否退件？',
  ChecklistResult: '核单结果',
  ModifiedReason: '改单原因',
  WsTjRemark: '改单说明',
  WsTjReason: '删单理由',
  WsTjDelRemark: '删单说明',
  ModifiedWsTjTips: '其他原因时需补充说明',
  FaceOrderPrintTime: '快递面单打印时间',
  CourierNumber: '快递单号',
  RefContainerNo: '参考箱号',
  isWeigh: '是否称重',
  isChecklist: '是否核单',
  isReturn: '是否退件',
  ChecklistTip: '选择的数据中包含未称重数据，请检查。',
  cannotEditOutData: '已出库的数据不能编辑',
  alreadyChecklist: '该业务已经核单，请检查。',
  delChecklistData: '包含已核单数据，不能删除。',
  repeatPackingData: '包含已装箱数据，不能重复装箱，请检查。',
  ChecklistTipOne: '选择的数据中包含未称重数据，是否核单？',
  RegistrationSlip: '登记面单',
  ContainerNoEditor: '编辑货箱编号',
  PerContainerNo: '箱号前缀(FBA编号):',
  boxNum: '箱数:',
  boxSeq: '箱序号:',
  boxSeqType3: '3位长度',
  boxSeqType6: '6位长度',
  boxSeqTooLong: '箱序号超过最大值[{0}]，请检查',
  duplicateContainerNo: '货箱编号[{0}]已存在，请重新填写',
  shipmentIdNotNull: '请先维护shipment Id!',
  boxesNumberNotNull: '请先维护箱数!',
  cargoChineseNameNotNull: '请先维护中文品名!',
  cargoEnglishNameNotNull: '请先维护英文品名!',
  singleBoxWeightNotNull: '请先维护单货箱重量!',
  boxesSizeNotNull: '请先维护单箱尺寸!',
  boxSeqNotNull: '请先维护箱序号',
  deleteTheDetailRecord: '当前列表所有明细都会清空，是否继续？',
  overwriteTheDetailRecord: '当前列表所有明细会被覆盖为客户数据，是否继续？',
  overwriteTheDetailRecordByJobRelated: '当前列表所有明细会被覆盖为客户数据，是否继续？',
  continuePicking: '还未核单，是否继续装箱？',
  continueReturnGoods: '退件后将不处理拼柜等操作，是否继续？',
  editShipmentId: '货箱编号与ShipmentId不匹配，是否刷新货箱编号？',
  editActJmt: '货箱明细已有值，不允许修改汇总件重体信息！',
  storageAgeEdit: '库龄调整',
  storageAgeEditDay: '天(自动计算/实际)',
  storageAgeEditWeek: '周(自动计算/实际)',
  Packing: '装箱',
  ExWarehouse: '出库',
  weightOpCannotChecklist: '不允许保存，如需核单，请点击【称重并核单】按钮操作。',
  saveCheckContainerNoFail: '明细存在数据未维护货箱编号，请检查！',
  saveCheckShipmentIdFail: '明细存在数据未维护Shipment Id，请检查！',
  saveCheckQuantityFail: '明细存在数据未维护单货箱重量，请检查！',
  saveCheckBoxLengthFail: '明细存在数据未维护货箱长度，请检查！',
  saveCheckBoxWidthFail: '明细存在数据未维护货箱宽度，请检查！',
  saveCheckBoxHeightFail: '明细存在数据未维护货箱高度，请检查！',
  saveCheckChineseCargoNameFail: '明细存在数据未维护中文品名，请检查！',
  saveCheckEnglishCargoNameFail: '明细存在数据未维护英文品名，请检查！',
  saveCheckBrandFail: '明细存在数据未维护品牌，请检查！',
  saveCheckBrandTypeFail: '明细存在数据未维护品牌类型，请检查！',
  FaceListCheckExpressDelivery: '目的地配送方式不是快递，不需要登记面单',
  FaceListCheckTip: '没有称重信息，是否继续登记快递面单信息？',
  PackingTipOne: '包含已退件数据，不能装箱，请核查。',
  PackingTipTwo: '选择的数据中包含核单未通过的数据，是否继续装箱？',
  ExWarehouseTip: '选择的数据中包含已出库数据，请核查',
  LabelingTime: '贴标时间',
  Labeling: '贴标',
  Pallet: '是否打托',
  PalletNo: '托盘编号',
  DaycareInformation: '打托信息',
  PreDeliveryTime: '预计送达日期',
  ActDeliveryTime: '实际送达日期',
  LogisticsNo: '物流单号',
  OperationStatus: '国外仓操作状态',
  LogisticsNoEnd: '物流单号（尾程）',
  palletContainerNum: '已打托箱数',
  otherContainerNum: '散装箱数',
  updateIssueRemarks: '出库备注',
  DateOfService: '送达时间',
  onWarehouseInCheck: '选择的数据中包含待入库以外状态的数据，请检查',
  PleaseChooseADataEntry: '请选择一条数据！',
  ExternallyImportedDataCannotEdit: '外部导入数据，不可编辑。',
  CannotEditExternalData: '外部导入数据，不可编辑。',
  PleaseChooseDesignatedData: '请选择指定数据',
  CargoWareDoorstepVehicleDrivingButton: 'CargoWare-业务功能-客户门点-车辆行驶轨迹（点击按钮）',
  PlateOrderNumberCannotEmpty: '车牌号和提单号不能为空',
  NoAvailableAtThisTime: '暂无相关信息'

}
